/* eslint-disable no-unused-vars */
import React from "react";
import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { useStateContext } from "contexts/ContextProvider";
import AdminLayout from "./layout/AdminLayout";
import {
  Landing,
  AdminPage,
  Feedback,
  Services,
  Offices,
  Users,
} from "./pages";
import RequireAuth from "./contexts/RequireAuth";

function App() {
  const { auth } = useStateContext();
  const roles = ["admin", "sdo - personnel", "school personnel"];

  return (
    <Box>
      <Routes>
        <Route path="/" element={<Feedback />} />
        <Route path="/feedback" element={<Landing />} />
        <Route path="/healthcheck" element={<Feedback />} />
        <Route path="/repair-diagnostics" element={<Feedback />} />

        <Route element={<RequireAuth allowedRoles={roles} />}>
          <Route path="/" element={<AdminLayout />}>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/service" element={<Services />} />
            <Route path="/office" element={<Offices />} />
            <Route path="/users" element={<Users />} />
          </Route>
        </Route>
      </Routes>
    </Box>
  );
}

export default App;
